
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 10"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#006aa7","d":"M0 0h16v10H0z"}}),_c('path',{attrs:{"fill":"#fecc00","d":"M5 0h2v10H5z"}}),_c('path',{attrs:{"fill":"#fecc00","d":"M0 4h16v2H0z"}})])
          )
        }
      }
    